export const ChecarData = ({ data }) => {
  const dataUTC = new Date(data);
  const agoraUTC = new Date();
  return agoraUTC.getTime() <= dataUTC.getTime();
};
